// fpjs.js
// Manage FingerprintJs Pro initialization and mixpanel tracking

import { getItem, setItem } from '../resource/persist.js';
import { setFpJsData } from '../resource/mixpanel.js';
import { fingerprint as fingerprintDebug } from '../resource/debug.js';

const log = fingerprintDebug.extend('log:fpjs');

let fpProPromise;

/**
 *
 * @param {Object} options
 * @param {String} options.id
 *
 */
export const fpProGetLinkedIdForUserId = async ({ id }) => {
  if (!fpProPromise) return;
  log('fpProGetLinkedIdForUserId start', { id });
  const fpPro = await fpProPromise;
  fpPro.get({ linkedId: `user-${id}` });
  log('fpProGetLinkedIdForUserId done', { id });
};

/**
 *
 * @param {Object} options
 * @param {String} options.fpJsAPIKey
 * @param {String} options.fpJsEndpoint
 * @param {String} options.fpJsRegion
 * @param {String} options.clientId
 * @param {String} options.userId
 */
export const initFpJsPro = async ({
  fpJsAPIKey,
  fpJsEndpoint,
  fpJsRegion,
  clientId,
  userId,
}) => {
  const persistedVisitorId = await getItem('_fpId');
  let visitorId = persistedVisitorId;
  let ip;

  if (fpJsAPIKey) {
    log('initFpJsPro start', { fpJsAPIKey, fpJsEndpoint, fpJsRegion });
    const FpPro = await import('@fingerprintjs/fingerprintjs-pro');

    const options = {
      apiKey: fpJsAPIKey,
      region: fpJsRegion,
    };

    if (fpJsEndpoint) {
      options.endpoint = fpJsEndpoint;
    }

    fpProPromise = FpPro.load(options);

    const fpPro = await fpProPromise;
    const result = await fpPro.get({ extendedResult: true });
    visitorId = result?.visitorId;
    ip = result?.ip;

    fpPro.get({ linkedId: `client-${clientId}` });
    if (userId) fpPro.get({ linkedId: `user-${userId}` });
    log('initFpJsPro done', { visitorId, ip });
  }

  if (visitorId) {
    const fpJsData = {
      visitorId,
    };
    if (ip) fpJsData.ip = ip;

    setFpJsData(fpJsData);
    return setItem('_fpId', visitorId);
  }
};

export const initFpJsOSS = async () => {
  const persistedVisitorId = await getItem('_fpIdOpenSource');
  let visitorId = persistedVisitorId;
  if (!persistedVisitorId) {
    log('initFpJsOSS start');
    const FpOSS = await import('@fingerprintjs/fingerprintjs');
    const fposs = await FpOSS.load();
    const result = await fposs.get();
    visitorId = result?.visitorId;
    log('initFpJsOSS done', { visitorId });
  }
  setFpJsData({
    visitorIdOpenSource: visitorId,
  });
  return setItem('_fpIdOpenSource', visitorId);
};

export const getFpIdOSS = async () => getItem('_fpIdOpenSource');

export const getFpIdPro = async () => getItem('_fpId');
